import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Task } from './task';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {

  @Input() public task?: Task;
  @Output() public deleted: EventEmitter<void> = new EventEmitter();
  @Output() public updated: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public delete(): void {
    this.deleted.emit();
  }

  public update(): void {
    this.updated.emit();
  }
}